import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {ProjectFormSenderField} from '@/features/projects/components/project-form/project-form-sender-field/ProjectFormSenderField'
import {ProjectFormSpecialistField} from '@/features/projects/components/project-form/project-form-specialist-field/ProjectFormSpecialistField'

export const EditReferringSpecialistFormFields = () => {
    return (
        <Grid columns={3} rowGap={4}>
            <GridItem spanColumn={2}>
                <ProjectFormSenderField />
            </GridItem>
            <ProjectFormSpecialistField />
        </Grid>
    )
}
